module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-modal c-modal--leaderboard"
  }, [_c('div', {
    staticClass: "c-modal__box c-modal--leaderboard__box"
  }, [_c('div', {
    staticClass: "c-modal__box__header t-modal-header"
  }, [_c('h2', {
    staticClass: "c-modal__box__header__title t-modal-header__text qa-leaderboard-modal-title"
  }, [_vm._v("\n        " + _vm._s(_vm.leaderboardModalData.title) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "c-modal__box__header__close"
  }, [_c('button', {
    staticClass: "c-modal__box__header__close__button t-modal-header__close",
    on: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "c-modal__box__content"
  }, [_c('table', {
    staticClass: "c-modal--leaderboard__table"
  }, [_c('thead', [_c('tr', _vm._l((_vm.leaderboardModalData.headers), function(field) {
    return _c('th', [_vm._v("\n              " + _vm._s(field) + "\n            ")])
  }), 0)]), _vm._v(" "), _c('tbody', {
    attrs: {
      "id": "leaderboard-table__body"
    }
  }, _vm._l((_vm.leaderboardReportData), function(record, index) {
    return _c('tr', [_c('td', {
      staticClass: "c-modal--leaderboard__rank t-leaderboard-rank",
      class: _vm.isPersonalPosition(record) ? 'qa-leaderboard-my-row-rank' : ''
    }, [_vm._v("\n              " + _vm._s(_vm.getRank(index + 1)) + "\n            ")]), _vm._v(" "), _vm._l((record), function(field, fieldIndex) {
      return (typeof field.id === 'undefined') ? _c('td', {
        class: _vm.isPersonalPosition(record) && fieldIndex === 1 ?
          'qa-leaderboard-my-row-name' : ''
      }, [_vm._v("\n              " + _vm._s(_vm.formatFieldValue(field, fieldIndex))), (_vm.isPersonalPosition(record) && fieldIndex === 1) ? _c('span', {
        staticClass: "fa fa-check-circle\n                               c-modal--leaderboard__table__icon__row__me\n                               t-leaderboard-rank\n                               qa-leaderboard-modal-my-row-icon",
        attrs: {
          "id": "personal-position",
          "aria-hidden": "false"
        }
      }, [_c('i', {
        staticClass: "u-hide"
      }, [_vm._v(_vm._s(_vm.$t('web.leaderboard_modal.hidden_you_indicator')))])]) : _vm._e()]) : _vm._e()
    })], 2)
  }), 0)]), _vm._v(" "), _c('paginate', {
    attrs: {
      "pagination": _vm.pagination,
      "pagingCallback": _vm.goToPage
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "c-modal__overlay"
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-13878789"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/components/LeaderboardModal.vue
// module id = 512
// module chunks = 1